/* Ceryn header: sticky state, offers bar, mega menu, search pill and mobile drawer. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeader() {
    var wrap = document.querySelector('[data-crh]');
    if (!wrap || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    var section = wrap.closest('.shopify-section') || wrap.parentElement;
    var promo = wrap.querySelector('[data-crh-promo]');
    var bar = wrap.querySelector('[data-crh-bar]');

    function measure() {
      var ph = promo ? promo.offsetHeight : 0;
      section.style.setProperty('--crh-promo-h', ph + 'px');
      root.style.setProperty('--header-height', bar.offsetHeight + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    bar.addEventListener('transitionend', function (e) { if (e.target === bar.firstElementChild) measure(); });

    var ticking = false;
    function onScroll() {
      ticking = false;
      var limit = (promo ? promo.offsetHeight : 0) + 8;
      wrap.classList.toggle('is-scrolled', window.scrollY > limit);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    var msgs = promo ? promo.querySelectorAll('.crh-msg') : [];
    if (msgs.length > 1 && !reduce) {
      var i = 0;
      var paused = false;
      promo.addEventListener('mouseenter', function () { paused = true; });
      promo.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        var cur = msgs[i];
        i = (i + 1) % msgs.length;
        var next = msgs[i];
        cur.classList.remove('is-on');
        cur.classList.add('is-out');
        next.classList.remove('is-out');
        next.classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-out'); }, 650);
      }, 4200);
    }

    /* The pill opens Dawn's predictive search modal; stopPropagation keeps
       details-modal's body click handler from closing it straight away. */
    var pill = wrap.querySelector('[data-crh-search]');
    var summary = wrap.querySelector('.header__search summary');
    if (pill && summary) {
      pill.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); summary.click(); });
    }

    var items = wrap.querySelectorAll('.crh-li.has-dd, .crh-li.has-mega');
    function closeAll(except) {
      items.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var t = li.querySelector('.crh-top');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (li) {
      var top = li.querySelector('.crh-top');
      var timer;
      function open() { clearTimeout(timer); closeAll(li); li.classList.add('is-open'); top.setAttribute('aria-expanded', 'true'); }
      function close() { clearTimeout(timer); li.classList.remove('is-open'); top.setAttribute('aria-expanded', 'false'); }
      li.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(open, 70); });
      li.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(close, 180); });
      top.addEventListener('click', function (e) {
        if (!li.classList.contains('is-open') && window.matchMedia('(hover: none)').matches) { e.preventDefault(); open(); }
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); top.focus(); }
        if (e.key === 'ArrowDown' && e.target === top) { e.preventDefault(); open(); var f = li.querySelector('.crh-dd a, .crh-mega a'); if (f) f.focus(); }
      });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.crh-li')) closeAll(); });

    initDrawer();
  }

  function initDrawer() {
    var drawer = document.getElementById('crh-drawer');
    if (!drawer) return;
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    var panel = drawer.querySelector('.crh-panel');
    var closeBtn = drawer.querySelector('[data-crh-close-btn]');
    var openers = document.querySelectorAll('[data-crh-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      root.classList.add('crh-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      root.classList.remove('crh-lock');
      panel.style.transform = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-crh-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll('a[href], button, input:not([type="hidden"]), summary');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1100 && drawer.classList.contains('is-open')) close(); });

    drawer.querySelectorAll('.crh-mnav > li > details').forEach(function (d, _, all) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        all.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });

    var startX = 0, startY = 0, dx = 0, dragging = false;
    panel.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; dx = 0; dragging = false;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      var x = e.touches[0].clientX - startX;
      var y = e.touches[0].clientY - startY;
      if (!dragging && Math.abs(x) > 12 && Math.abs(x) > Math.abs(y) * 1.4 && x < 0) { dragging = true; panel.classList.add('is-dragging'); }
      if (dragging) { dx = Math.min(0, x); panel.style.transform = 'translateX(' + dx + 'px)'; }
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (!dragging) return;
      panel.classList.remove('is-dragging');
      if (dx < -80) close(); else panel.style.transform = '';
      dragging = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader); else initHeader();
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelector('[data-crh]')) return;
    document.querySelectorAll('body > #crh-drawer').forEach(function (d) { d.remove(); });
    root.classList.remove('crh-lock');
    initHeader();
  });
})();
